module.exports = __webpack_public_path__ + "img/profile-img.d2d4753d.png";